export const getDocumentType = (document: string) => {
	const cleanedDocument = document.replace(/[.\-\/\s]/g, "");
	
	if (cleanedDocument.length === 11) {
		return "Pessoa Física";
	} else if (cleanedDocument.length === 14) {
		return "Pessoa Jurídica";
	}
	return "unknown";
};